import React from 'react';
import withSlideState from './withSlideState';
import LeadForm from './LeadForm';

const Form = (props) => {
  const App = withSlideState(LeadForm);

  const {
    slides: incomingSlides,
    progressBarColor,
    showProgressBar,
    showProgressText,
    progressBarText,
    questionFontSize,
    questionColor,
    answerFontSize,
    answerTextColor,
    answerBgColor,
    answerSelectedBgColor,
    answerSelectedTextColor,
    answerHoverBgColor,
    answerHoverTextColor,
    disclaimerText
  } = props;

  const slides = Array.isArray(incomingSlides) ? incomingSlides : [];

  if (slides.length === 0) {
    return <div style={{ padding: 20 }}>No slides configured yet.</div>;
  }

  return (
    <App
      slides={slides}
      progressBarColor={progressBarColor}
      showProgressBar={showProgressBar}
      showProgressText={showProgressText}
      progressBarText={progressBarText}
      questionFontSize={questionFontSize}
      questionColor={questionColor}
      answerFontSize={answerFontSize}
      answerTextColor={answerTextColor}
      answerBgColor={answerBgColor}
      answerSelectedBgColor={answerSelectedBgColor}
      answerSelectedTextColor={answerSelectedTextColor}
      answerHoverBgColor={answerHoverBgColor}
      answerHoverTextColor={answerHoverTextColor}
      disclaimerText={disclaimerText}
    />
  );
};

export default Form;
